// AUTO-GENERATED by scripts/factory_pipeline/uranium_overlays_gen.py — DO NOT HAND-EDIT.
// All visual mechanics live in overlayKit/Tag. This file is pure DATA (one row per overlay).
import React from "react";
import { AbsoluteFill } from "remotion";
import { PaletteProvider, Tag } from "./overlayKit";
import { URANIUM_PALETTE } from "./UraniumPalette";

export const UraniumSeg4plus: React.FC = () => (
  <PaletteProvider value={URANIUM_PALETTE}>
    <AbsoluteFill>
      {/* ── PART 6 ── */}
      <Tag inS={64.8} outS={68.3} label="CIGAR LAKE MINE" sub="NORTHERN SASKATCHEWAN" color="secondary" />
      <Tag inS={69.8} outS={72.3} value={20} suffix="%" valueS={70.088} endS={70.87} label="URANIUM GRADE" sub="HERE AT CIGAR LAKE" color="secondary" />
      <Tag inS={74.4} outS={77.2} value={100} suffix="x" valueS={75.023} endS={76.09} label="RICHER THAN AVERAGE" sub="MOST MINES: 2%" color="primary" />
      {/* ── PART 8 ── */}
      <Tag inS={90.6} outS={93.1} value={200} valueS={91.184} endS={92.3} label="STEEL FREEZE-PIPES" sub="DRILLED INTO THE ROCK" color="primary" />
      <Tag inS={93.9} outS={96.0} value={8} suffix=" DAYS" valueS={94.481} endS={95.72} label="TO INSTALL EACH PIPE" sub="ONE AT A TIME" color="primary" />
      <Tag inS={98.4} outS={101.5} value={-30} suffix="°C" valueS={99.404} endS={100.51} label="CALCIUM-CHLORIDE BRINE" sub="FREEZE-PLANT COOLANT" color="primary" />
      {/* ── PART 10 ── */}
      <Tag inS={115.7} outS={117.7} value={50} suffix=" M" valueS={116.191} endS={116.83} label="REMOTE-CONTROLLED" sub="OPERATORS THIS FAR BACK" color="secondary" />
      <Tag inS={119.0} outS={123.3} label="TUNGSTEN CARBIDE" sub="2ND HARDEST · AFTER DIAMOND" color="secondary" />
      {/* ── PART 11 ── */}
      <Tag inS={132.9} outS={135.0} value={20} suffix=" MIN" valueS={133.478} endS={134.1} label="AIR FULLY CYCLED" sub="RADIATION CONTROL" color="secondary" />
      {/* ── PART 12 ── */}
      <Tag inS={144.9} outS={148.0} label="RADIOACTIVE SLURRY" sub="SOLID ROCK → LIQUID" color="secondary" />
      {/* ── PART 13 ── */}
      <Tag inS={157.6} outS={160.5} label="SULFURIC ACID" sub="DISSOLVES ONLY THE URANIUM" color="secondary" />
      {/* ── PART 14 ── */}
      <Tag inS={176.3} outS={179.2} label="ACIDS THAT EAT STEEL" sub="STRONGER THAN WATER" color="secondary" />
      {/* ── PART 15 ── */}
      <Tag inS={184.2} outS={187.6} value={1085} suffix="°C" valueS={184.956} endS={186.6} label="ROASTING FURNACE" sub="HOT ENOUGH TO MELT COPPER" color="secondary" />
      {/* ── PART 16 ── */}
      <Tag inS={200.8} outS={203.3} label="YELLOWCAKE" sub="DENSE BLACK POWDER" color="secondary" />
      {/* ── PART 17 ── */}
      <Tag inS={208.5} outS={211.2} value={55} suffix=" GAL" valueS={208.989} endS={210.13} label="STEEL DRUMS" sub="SEALED & STAMPED" color="secondary" />
      {/* ── PART 18 ── */}
      <Tag inS={222.2} outS={225.4} label="STILL LOCKED AWAY" sub="ENERGY OUT OF REACH" color="secondary" />
      {/* ── PART 19 ── */}
      <Tag inS={230.6} outS={234.0} label="ROLLING VAULTS" sub="REINFORCED · SHIELDED" color="secondary" />
      {/* ── PART 20 ── */}
      <Tag inS={238.2} outS={241.2} label="ROUTE CLASSIFIED" sub="EVEN HIS FAMILY CAN'T KNOW" color="secondary" />
      {/* ── PART 21 ── */}
      <Tag inS={249.8} outS={253.0} label="USELESS TO A THIEF" sub="RAW URANIUM IS INERT" color="secondary" />
      {/* ── PART 22 ── */}
      <Tag inS={257.3} outS={260.2} value={3} suffix=" DAYS" valueS={257.995} endS={258.64} label="THE JOURNEY" sub="THOUSANDS OF KM" color="secondary" />
      <Tag inS={269.3} outS={272.6} label="MOST-GUARDED BUILDINGS" sub="ON EARTH" color="secondary" />
      {/* ── PART 23 ── */}
      <Tag inS={278.9} outS={282.0} label="CONVERSION FACILITY" sub="WHERE IT TURNS DANGEROUS" color="secondary" />
      {/* ── PART 24 ── */}
      <Tag inS={300.9} outS={304.1} value={550} suffix="°C" valueS={301.927} endS={303.23} label="FLUORINATION" sub="ELEMENTAL FLUORINE GAS" color="secondary" />
      {/* ── PART 25 ── */}
      <Tag inS={312.2} outS={317.0} label="UF6" sub="EATS SKIN · DISSOLVES BONE" color="secondary" />
      {/* ── PART 26 ── */}
      <Tag inS={318.9} outS={322.0} label="NICKEL ALLOY & ALUMINUM" sub="ONLY METALS THAT SURVIVE UF6" color="secondary" />
      {/* ── PART 27 ── */}
      <Tag inS={329.4} outS={332.0} value={99.3} decimals={1} suffix="%" valueS={330.198} endS={331.72} label="U-238" sub="DEAD WEIGHT" color="secondary" />
      <Tag inS={332.5} outS={335.6} value={0.7} decimals={1} suffix="%" valueS={333.263} endS={334.46} label="U-235" sub="THE ISOTOPE THAT SPLITS" color="primary" />
      {/* ── PART 28 ── */}
      <Tag inS={348.5} outS={350.8} value={1} suffix="% LIGHTER" valueS={349.296} endS={350.47} label="U-235 vs U-238" sub="THE ONLY DIFFERENCE" color="primary" />
      {/* ── PART 29 ── */}
      <Tag inS={353.9} outS={356.7} value={3} suffix=" LB" valueS={354.811} endS={355.46} label="OUT OF 1,000" sub="LIKE IDENTICAL TWINS" color="primary" />
      {/* ── PART 30 ── */}
      <Tag inS={365.9} outS={369.4} value={56.5} decimals={1} suffix="°C" valueS={366.711} endS={368.32} label="UF6 SUBLIMES" sub="SOLID → GAS" color="secondary" />
      {/* ── PART 31 ── */}
      <Tag inS={375.2} outS={377.7} value={14} suffix=" TON" valueS={375.592} endS={376.43} label="STEEL CYLINDERS" sub="SOLIDIFY OVER 5 DAYS" color="secondary" />
      {/* ── PART 32 ── */}
      <Tag inS={382.0} outS={384.6} label="DAY 40" sub="AT THE ENRICHMENT PLANT" color="primary" />
      <Tag inS={398.2} outS={402.1} value={70000} suffix=" RPM" valueS={398.73} endS={401.92} label="CENTRIFUGE ROTOR" sub="50,000–70,000 RPM" color="primary" />
      {/* ── PART 33 ── */}
      <Tag inS={402.2} outS={405.1} value={2} suffix="x" valueS={402.596} endS={403.41} label="A FIGHTER JET" sub="ROTOR vs JET ENGINE" color="primary" />
      <Tag inS={406.4} outS={409.2} value={500} suffix=" M/S" valueS={407.577} endS={408.48} label="ROTOR WALL SPEED" sub="400–500 M PER SECOND" color="primary" />
      {/* ── PART 34 ── */}
      <Tag inS={410.9} outS={414.0} label="IT DISINTEGRATES" sub="FAILURE = DESTRUCTION" color="secondary" />
      {/* ── PART 35 ── */}
      <Tag inS={420.3} outS={423.0} label="U-238 → OUTER WALL" sub="HEAVIER · FLUNG OUT" color="secondary" />
      <Tag inS={423.3} outS={426.6} label="U-235 → CENTER" sub="LIGHTER · CONCENTRATES" color="primary" />
      {/* ── PART 36 ── */}
      <Tag inS={435.9} outS={443.1} value={5} suffix="%" valueS={442.058} endS={442.88} label="ENRICHMENT CLIMB" sub="0.7% → 5% U-235" color="primary" />
      <Tag inS={443.3} outS={446.1} value={8} suffix=" SWU" valueS={443.974} endS={445.23} label="PER KILOGRAM" sub="OF 5% ENRICHED U" color="primary" />
      <Tag inS={449.3} outS={455.5} value={140000} suffix=" SWU/YR" valueS={451.996} endS={453.45} label="ONE 1,000-MW REACTOR" sub="EVERY YEAR" color="primary" />
      {/* ── PART 37 ── */}
      <Tag inS={455.9} outS={460.2} value={6} suffix=" NATIONS" valueS={456.57} endS={457.31} label="ENRICH URANIUM" sub="ONLY 6 ON EARTH" color="primary" />
      {/* ── PART 38 ── */}
      <Tag inS={469.4} outS={472.4} label="URANIUM DIOXIDE" sub="ENRICHED UO2 POWDER" color="primary" />
      {/* ── PART 39 ── */}
      <Tag inS={487.4} outS={490.5} label="EVERY GRAIN TO SPEC" sub="ASTM STANDARD" color="primary" />
      {/* ── PART 40 ── */}
      <Tag inS={514.7} outS={516.6} value={10} suffix=" G" valueS={515.654} endS={516.46} label="GREEN PELLET" sub="PRESSED UO2 POWDER" color="primary" />
      {/* ── PART 41 ── */}
      <Tag inS={526.8} outS={529.4} label="ONE CRACK = FAILURE" sub="THE STAKES ARE THAT HIGH" color="secondary" />
      {/* ── PART 42 ── */}
      <Tag inS={532.2} outS={535.6} value={1750} suffix="°C" valueS={533.511} endS={534.91} label="SINTERING FURNACE" sub="1,600–1,750°C" color="secondary" />
      <Tag inS={537.2} outS={540.2} value={24} suffix=" HRS" valueS={537.864} endS={538.67} label="PELLETS DENSIFY" sub="PORES CLOSE" color="primary" />
      {/* ── PART 43 ── */}
      <Tag inS={550.3} outS={553.3} label="NOTHING WASTED" sub="UO2 DUST RECYCLED" color="primary" />
      {/* ── PART 44 ── */}
      <Tag inS={555.4} outS={557.6} value={4} suffix=" M" valueS={556.591} endS={557.12} label="ZIRCONIUM TUBE" sub="FUEL-ROD CLADDING" color="primary" />
      <Tag inS={557.7} outS={560.8} value={300} valueS={558.553} endS={560.0} label="PELLETS PER ROD" sub="STACKED END-TO-END" color="primary" />
      {/* ── PART 45 ── */}
      <Tag inS={571.8} outS={574.8} label="HELIUM-SEALED" sub="WELDED END PLUGS" color="primary" />
      {/* ── PART 46 ── */}
      <Tag inS={574.9} outS={578.2} value={37} valueS={575.005} endS={576.24} label="FUEL RODS" sub="BUNDLED INTO ONE ASSEMBLY" color="primary" />
      {/* ── PART 47 ── */}
      <Tag inS={593.8} outS={598.0} label="ARMORED CASKS" sub="SURVIVE CRASHES & MISSILES" color="secondary" />
      {/* ── PART 48 ── */}
      <Tag inS={612.3} outS={615.6} value={40} suffix=" FT" valueS={613.132} endS={613.99} label="REACTOR VESSEL" sub="8-INCH STEEL WALLS" color="primary" />
      {/* ── PART 49 ── */}
      <Tag inS={627.4} outS={630.6} label="CHAIN REACTION" sub="U-235 SPLITS · THEN BILLIONS" color="primary" />
      {/* ── PART 50 ── */}
      <Tag inS={643.9} outS={647.6} value={750} suffix=" MW" valueS={645.106} endS={646.66} label="PER GENERATOR" sub="ELECTRICITY OUTPUT" color="primary" />
      <Tag inS={647.7} outS={649.8} value={500000} valueS={648.438} endS={649.6} label="PEOPLE POWERED" sub="FROM ONE REACTOR" color="secondary" />
      {/* ── PART 51 ── */}
      <Tag inS={656.5} outS={659.2} value={26} suffix=" FT" valueS={657.122} endS={658.0} label="COOLING POOLS" sub="AT LEAST 10 YEARS DEEP" color="primary" />
      <Tag inS={659.8} outS={664.8} value={700000} valueS={660.419} endS={661.54} label="SPENT FUEL RODS" sub="WORLDWIDE · UNDERWATER" color="secondary" />
      {/* ── PART 52 ── */}
      <Tag inS={675.2} outS={678.2} value={70} suffix=" YEARS" valueS={675.755} endS={676.46} label="TO MASTER THIS" sub="THE MOST EXTREME PROCESS" color="secondary" />
      {/* ── PART 54 ── */}
      <Tag inS={705.2} outS={709.0} value={3000} suffix="°C" valueS={706.08} endS={707.03} label="NEXT: JET ENGINES" sub="SURVIVE 3,000°C" color="secondary" />
      <Tag inS={709.6} outS={713.5} label="SUBSCRIBE" sub="FACTORY FILES · NEW VIDEO WEEKLY" color="primary" />
    </AbsoluteFill>
  </PaletteProvider>
);

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
